import Utils from "../utils/utils"
const utilsHelper = new Utils()

export default class PagePlugin {

    constructor(container_id, config){
        this.config = config
        this.target_element = null
        this.setting = null
        this.plugin_type = null
        this.from = null
        this.is_show = false
        this.platform = ''
        this.retry_time = 5
        this.container_id = container_id
        this.plugin_storage_key = `_opt99_${container_id}_plugin`
        // 一天過期
        this.expired_time = 1000 * 60 * 60 * 24
    }

    initSetting (setting, plugin_type, from,value_data){
        this.setting = setting
        this.plugin_type = plugin_type
        this.from = from
        this.value_data = value_data
        console.log('initSetting', this.setting)
        let plugin_selector = `[opt99-plugin="${plugin_type}"][opt99-vid="${setting.view_id}"] > div[opt99-id="${setting.view_key}"]`
        let plugin_ele = document.querySelector(plugin_selector)
        if (plugin_ele) {
            this.target_element = plugin_ele.parentElement
            console.log('target_plugin:',this.target_element)
        }
        this.platform = utilsHelper.checkPlatform()

        return plugin_ele
    }

    initValue(){
        switch (this.plugin_type) {
            case 'online_user':
                this.onlineUser()
                break
            case 'sales_counter':
                this.salesCounter()
                break
            default:
        }
    }

    display(){
        if (this.is_show) {
            this.target_element.style.display = 'flex'
        }
    }

    onlineUser(){
        let counter_ele = this.target_element.querySelector('span[name="counter"]')
        let number_text = this.setting.olu_num
        if (this.from === 'preview') {
            if (this.setting.is_interval_count === 1) {
                let now_hr = new Date().getHours()
                let level = 0
                if (now_hr >=8 && now_hr < 13) {
                    level = 1
                }
                else if(now_hr >=13 && now_hr < 19) {
                    level = 2
                }
                else if (now_hr >=19 && now_hr < 2) {
                    level = 3
                }

                let itn = parseInt((this.setting.top - this.setting.bot) / 4)
                let ibot = this.setting.bot + level * itn
                let itop = this.setting.bot + level * itn + itn
                console.log('ibot',ibot)
                console.log('itop',itop)
                number_text = utilsHelper.getRandomNumber(ibot, itop)
            }
            else {
                number_text = utilsHelper.getRandomNumber(this.setting.bot, this.setting.top)
            }
            
        }
        else {
            let is_interval_count = this.setting.is_interval_count
            if (is_interval_count === undefined) {
                is_interval_count = this.setting.olu_is_interval_count
            }
            let top = this.setting.top
            let bot = this.setting.bot
            if (top === undefined) {
                top = this.setting.olu_top
            }
            if (bot === undefined) {
                bot = this.setting.olu_bot
            }
            if (isNaN(parseInt(bot)) || isNaN(parseInt(top))){
                top = 0
                bot = 0
            }
            if (is_interval_count === 1) {
                let now_hr = new Date().getHours()
                let level = 0
                if (now_hr >=8 && now_hr < 13) {
                    level = 1
                }
                else if(now_hr >=13 && now_hr < 19) {
                    level = 2
                }
                else if (now_hr >=19 && now_hr < 2) {
                    level = 3
                }
                let itn = parseInt((top - bot) / 4)
                let ibot = bot + level * itn
                let itop = bot + level * itn + itn
                if (ibot === 0 && itop === 0) {
                    if (this.setting.olu_num) {
                        number_text = this.setting.olu_num
                    }
                    else {
                        number_text = this.setting.num
                    }
                }
                else {
                    number_text = utilsHelper.getRandomNumber(ibot, itop)
                }
                
            }
            else {
                if (bot === 0 && top === 0) {
                    if (this.setting.olu_num) {
                        number_text = this.setting.olu_num
                    }
                    else {
                        number_text = this.setting.num
                    }
                }
                else {
                    number_text = utilsHelper.getRandomNumber(bot, top)
                }
                
            }
        }
        counter_ele.innerText = number_text
        this.is_show = true
    }

    async salesCounter(){
        let that = this
        let counter_ele = this.target_element.querySelector('span[name="counter"]')
        let number_text = ''
        let value_result = ''
        if (this.value_data) {
            value_result = this.value_data['sales_counter'].find(function(result){
                if (that.setting.id) {
                    return result.id === that.setting.id
                }
                else {
                    return result.id === that.setting.sct_id
                }
                
            })
        }

        console.log('sales_counter_value_result:', value_result)
        if (value_result !== '' && value_result !== undefined && value_result !== null) {
            number_text = value_result.current_num
        }
        else {
            number_text = this.setting.current_num
        }
        if (this.from === 'preview') {
            number_text = this.setting.init
        }
        if (number_text !== '') {
            this.is_show = true
        }
        counter_ele.innerText = number_text



        // 儲存哪些商品有銷售計數器
        console.log('plugin_platform:', this.platform)

        // let plugin_storage = {}
        // try {
        //     plugin_storage = localStorage.getItem(this.plugin_storage_key)
        //     if (plugin_storage) {
        //         plugin_storage = JSON.parse(plugin_storage)
        //     }
        //     else {
        //         plugin_storage = {}
        //     }
        // } catch (error) {
        //     plugin_storage = {}
        // }

        let plugin_id = this.setting.sct_id
        if (!plugin_id) {
            plugin_id = this.setting.id
        }
        this.recordViewPlugin(plugin_id, this.platform, this.plugin_type)
        // if (this.from === 'preview') {
        //     plugin_id = this.setting.id
        // }

        // let product_id = ''

        // switch (this.platform) {
        //     case 'shopline':
        //         if (!window.app) {
        //             for (let idx = 0 ; idx <= this.retry_time; idx++) {
        //                 await utilsHelper.sleep(2000);
        //                 if (!window.app) {
        //                     continue
        //                 }
        //                 break
        //             }
        //             product_id = this.getProductIdShopline()
        //         }
        //         else {
        //             product_id = this.getProductIdShopline()
        //         }
                
        //         break;
        //     case 'cyberbiz':
        //         product_id = this.getProductIdCyberbiz()
        //         break;
        //     case '91app':
        //         product_id = this.getProductIdNineyi()
        //         break;
        //     default:
        //         console.log('unknown_plugin_platform')
        // }

        // if (product_id){
        //     plugin_storage = this.createStore(
        //         plugin_storage, this.plugin_type, product_id, plugin_id
        //     )
        // }

        // console.log('plugin_storage:', plugin_storage)
        // localStorage.setItem(this.plugin_storage_key, JSON.stringify(plugin_storage))
    }

    baSlider(plugin_ele){
        let slider_input = plugin_ele.querySelector('div[name="container"] > input')
        slider_input.addEventListener('input', function(event){
            let percent = 50
            if (!isNaN(parseInt(event.target.value))) {
                percent = parseInt(event.target.value)
            }
            let container = event.target.closest('div[name="container"]')
            let slider_new = container.querySelector('div[name="slider-new"]')
            let slider_btn = container.querySelector('div[name="opt99-slider-btn"]')
            let direction = 'horizontal'
            if (container) {
                if (container.getAttribute('direction')) {
                    direction = container.getAttribute('direction')
                }
            }
            if (direction === 'horizontal') {
                if (slider_new) {
                    slider_new.style.height = 'auto'
                    slider_new.style.width = `${percent}%`
                }
                if (slider_btn) {
                    slider_btn.style.left = `${percent}%`
                    slider_btn.style.top = '50%'
                }
            }
            else {
                if (slider_new) {
                    slider_new.style.height = `${percent}%`
                    slider_new.style.width = 'auto' 
                }
                if (slider_btn) {
                    slider_btn.style.left = '50%'
                    slider_btn.style.top = `${percent}%` 
                }
            }
        })
        this.target_element = plugin_ele
        this.is_show = true
    }

    getProductIdShopline(){
        console.log('this.setting:',this.setting)
        let product_id = ''
        let product = null
        // 取本頁product
        if (window.location.href.includes('/products/') === true) {
            
            for (let idx = 0; idx < window.app._invokeQueue.length - 1; idx++) {
                let param =  window.app._invokeQueue[idx]
                if (param[1] !== 'value') {
                    continue;
                }

                if (param[2][0] === 'product') {
                    product = param[2][1]
                    break;
                }
            }

            if (product) {
                product_id = product._id
            }
        }

        return product_id
    }

    getProductIdCyberbiz(){
        console.log('this.setting:',this.setting)
        let product_id = ''
        if(window.location.href.includes('/products/')) {
            let product = window.c12t.product
            if (product) {
                product_id = product.id
            }
        }
        else if (window.location.href.includes('/events/')) {
            let btns = Array.from(document.querySelectorAll('.add-button'))
            let products = btns.map(function(btn){
                let product = btn.getAttribute('data-id') 
                return product
            })
            product_id = products
        }

        return product_id
    }

    getProductIdNineyi(){
        let path = window.location.pathname.toLocaleUpperCase()
        let product_id = ''
        if (path.includes('/SALEPAGE/INDEX/')) {

            let url_product_id = path.replace('/SALEPAGE/INDEX/', '')
            let ele_product_id = document.querySelector('div[ng-bind="::SalePageIndexCtrl.SalePageId"]').innerText
            
            if (url_product_id !== ele_product_id) {
                product_id = ele_product_id
            }
            else {
                product_id = url_product_id
            }
        }
        return product_id
    }

    createStore(plugin_storage, plugin_type, product_id, plugin_id){
        if (!plugin_storage.view_plugin) {
            plugin_storage.view_plugin = {}
        }
        if (!plugin_storage.view_plugin[plugin_type]) {
            plugin_storage.view_plugin[plugin_type] = {}
        }
        if (!plugin_storage.view_plugin[plugin_type][product_id]) {
            plugin_storage.view_plugin[plugin_type][product_id] = {}
        }
        plugin_storage.view_plugin[plugin_type][product_id][plugin_id] = new Date().getTime()

        return plugin_storage
    }

    purchaseEvent(products){
        let that = this
        let event_map = {}
        
        let plugin_storage = localStorage.getItem(this.plugin_storage_key)
        if (plugin_storage) {
            plugin_storage = JSON.parse(plugin_storage)
        }
        else {
            plugin_storage = {
                'view_plugin': {}
            }
        }
        let plugin_types = [
            'sales_counter'
        ]

        console.log('purchase_plugin:', plugin_storage)

        products.forEach(function(product){
            let id = product.content_id
            console.log('id:',id)
            plugin_types.forEach(function(plugin_type){
                let events = []
                if (plugin_storage.view_plugin[plugin_type] && plugin_storage.view_plugin[plugin_type][id]) {
                    let plugin_ids = Object.keys(plugin_storage.view_plugin[plugin_type][id])
                    plugin_ids.forEach(function(plugin_id){
                        let view_at = plugin_storage.view_plugin[plugin_type][id][plugin_id]
                        let now_at = new Date().getTime()
                        let d = now_at - view_at
                        if (d < that.expired_time) {
                            for (let idx = 0; idx < product.quantity; idx++) {
                                events.push(parseInt(plugin_id))
                            }
                        }
                    })
                    // delete plugin_storage.view_plugin[plugin_type][id]
                }
                event_map[plugin_type] = events
            })
        })
        return event_map
    }

    async recordViewPlugin(plugin_id, platform, plugin_type){
        let plugin_storage = {}
        try {
            plugin_storage = localStorage.getItem(this.plugin_storage_key)
            if (plugin_storage) {
                plugin_storage = JSON.parse(plugin_storage)
            }
            else {
                plugin_storage = {}
            }
        } catch (error) {
            plugin_storage = {}
        }

        let product_id = ''

        if (!platform) {
            platform = utilsHelper.checkPlatform()
        }

        switch (platform) {
            case 'shopline':
                if (!window.app) {
                    for (let idx = 0 ; idx <= this.retry_time; idx++) {
                        await utilsHelper.sleep(2000);
                        if (!window.app) {
                            continue
                        }
                        break
                    }
                    product_id = this.getProductIdShopline()
                }
                else {
                    product_id = this.getProductIdShopline()
                }
                
                break;
            case 'cyberbiz':
                product_id = this.getProductIdCyberbiz()
                break;
            case '91app':
                product_id = this.getProductIdNineyi()
                break;
            default:
                console.log('unknown_plugin_platform')
        }

        if (product_id){
            if (typeof(product_id) === 'string') {
                plugin_storage = this.createStore(
                    plugin_storage, plugin_type, product_id, plugin_id
                )
            }
            else if(product_id.length !== undefined) {
                product_id.forEach((id) => {
                    plugin_storage = this.createStore(
                        plugin_storage, plugin_type, id, plugin_id
                    )
                })
            }

        }

        console.log('plugin_storage:', plugin_storage)
        localStorage.setItem(this.plugin_storage_key, JSON.stringify(plugin_storage))
    }
}
